(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-slider"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.best-sellers-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 4000,
    },
    breakpoints: {
      1200: {
        slidesPerView: 3
      },
      767: {
        slidesPerView: 2
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  document.querySelector('.slider-nav.next').addEventListener('click', function () {
    document.querySelector('.swiper-button-next').click();
  });

  document.querySelector('.slider-nav.prev').addEventListener('click', function () {
    document.querySelector('.swiper-button-prev').click();
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-articles-slider"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.blog-articles-slider', {
    slidesPerView: 3,
    spaceBetween: 20,
    autoHeight: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-slider"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.collection-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    loop: true,
    autoplay: {
      delay: 4000,
    },
    breakpoints: {
      992: {
        slidesPerView: 5
      },
      767: {
        slidesPerView: 3
      },
      500: {
        slidesPerView: 2
      }
    },
    navigation: {
      nextEl: '.collection-swiper-button-next',
      prevEl: '.collection-swiper-button-prev',
    }
  });

  document.querySelector('.collection-slider-nav.next').addEventListener('click', function () {
    document.querySelector('.collection-swiper-button-next').click();
  });

  document.querySelector('.collection-slider-nav.prev').addEventListener('click', function () {
    document.querySelector('.collection-swiper-button-prev').click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-cart-recommendations"]) return;
  try {
    
  class CartProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.loadRecommendations();

      const cartItems = document.getElementById('main-cart-items');
      if (!cartItems) return;

      this.cartObserver = new MutationObserver(() => this.scheduleRefresh());
      this.cartObserver.observe(cartItems, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this.cartObserver) this.cartObserver.disconnect();
      if (this.refreshTimeout) window.clearTimeout(this.refreshTimeout);
    }

    scheduleRefresh() {
      if (this.refreshTimeout) window.clearTimeout(this.refreshTimeout);

      this.refreshTimeout = window.setTimeout(() => this.loadRecommendations(), 50);
    }

    async loadRecommendations() {
      if (this.loading) {
        this.reloadPending = true;
        return;
      }

      const list = this.querySelector('[data-fb-cart-recommendation-list]');
      if (!list) return;

      this.loading = true;
      this.hidden = true;
      this.classList.remove('product-recommendations--loaded');
      list.replaceChildren();

      try {
        const cartResponse = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });

        if (!cartResponse.ok) return;

        const cart = await cartResponse.json();
        const cartItems = Array.isArray(cart.items) ? cart.items : [];
        const cartProductIds = new Set(
          cartItems
            .map((item) => item && item.product_id)
            .filter(Boolean)
            .map((productId) => String(productId))
        );
        const productIds = [...cartProductIds].slice(0, 6);

        if (!productIds.length) return;

        const limit = Number(this.dataset.limit) || 4;
        const selectedProductIds = new Set();

        const requestRecommendations = async (productId, intent) => {
          try {
            const url = new URL(this.dataset.recommendationsUrl, window.location.origin);
            url.searchParams.set('section_id', this.dataset.sectionId);
            url.searchParams.set('product_id', productId);
            url.searchParams.set('limit', limit);
            url.searchParams.set('intent', intent);

            const response = await fetch(url, { credentials: 'same-origin' });
            if (!response.ok) return [];

            const responseHtml = await response.text();
            const documentFragment = new DOMParser().parseFromString(responseHtml, 'text/html');

            return Array.from(documentFragment.querySelectorAll('[data-fb-cart-recommendation-card]'));
          } catch (error) {
            return [];
          }
        };

        const appendEligibleCards = (cards) => {
          let appended = 0;

          for (const card of cards) {
            if (selectedProductIds.size >= limit) break;

            const productId = card.dataset.fbRecommendationProductId;
            if (!productId || cartProductIds.has(productId) || selectedProductIds.has(productId)) continue;

            selectedProductIds.add(productId);
            list.append(card.cloneNode(true));
            appended += 1;
          }

          return appended;
        };

        for (const productId of productIds) {
          if (selectedProductIds.size >= limit) break;

          const complementaryCards = await requestRecommendations(productId, 'complementary');
          appendEligibleCards(complementaryCards);

          if (selectedProductIds.size < limit) {
            const relatedCards = await requestRecommendations(productId, 'related');
            appendEligibleCards(relatedCards);
          }
        }

        if (!selectedProductIds.size) return;

        this.hidden = false;
        this.classList.add('product-recommendations--loaded');
      } catch (error) {
      } finally {
        this.loading = false;

        if (this.reloadPending) {
          this.reloadPending = false;
          this.loadRecommendations();
        }
      }
    }
  }

  if (!customElements.get('cart-product-recommendations')) {
    customElements.define('cart-product-recommendations', CartProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-width-cta-with-collection-slider"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.side-collection-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    loop: true,
    autoplay: {
      delay: 4000,
    },
    breakpoints: {
      992: {
        slidesPerView: 3
      },
      767: {
        slidesPerView: 2
      },
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selected-blog-posts-slider"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.selected-blog-posts-slider', {
    slidesPerView: 1,
    spaceBetween: 10,
    autoHeight: true,
    loop: true,
    autoplay: {
      delay: 4000,
    },
    breakpoints: {
      992: {
        slidesPerView: 3
      },
      500: {
        slidesPerView: 2
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.usp-swiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      800: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 10
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
